module.exports = __webpack_public_path__ + "img/homeicon.f2319aa9.svg";